import { useState, useEffect } from 'react'
import useFetchAPI from '/src/hooks/api/fetch_api'

export default function useFetchSections(templateId) {
  const [sections, setSections] = useState(null)
  const { fetchAPI, status, responseData } = useFetchAPI('eav_sections')

  useEffect(() => {
    if (!templateId) return
    const params = { requestAction: 'READ', httpAction: 'get' }
    const query = { where: { eav_template_id: templateId } }
    const additionalResource = { path: 'eav_columns' }
    fetchAPI({ ...params, query, additionalResource })
  }, [templateId])

  useEffect(() => {
    if (status !== 'SUCCESS') return

    setSections(responseData.data[0].filter((s) => s.eav_columns.length > 0))
  }, [status, responseData])

  return sections
}
